<div class="dialog-container">
  <div
    mat-dialog-title
    class="close-div"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle
  >
    <h4>Rulebook update review</h4>
    <div class="title-actions">
      <span class="toggle-label" aria-hidden="true">Show:</span>
      <mat-button-toggle-group
        class="view-toggle-group"
        aria-label="Show"
        [value]="contentView"
        (change)="onContentViewChange($event.value)"
      >
        <mat-button-toggle value="compare" [disabled]="loading">
          Comparison
        </mat-button-toggle>
        <mat-button-toggle value="new" [disabled]="loading">
          Current
        </mat-button-toggle>
        <mat-button-toggle value="old" [disabled]="loading">
          Previous
        </mat-button-toggle>
      </mat-button-toggle-group>
      @if (showToggle) {
        <span class="toggle-divider" aria-hidden="true"></span>
        <span class="toggle-label" aria-hidden="true">Changes:</span>
        <mat-button-toggle-group
          class="view-toggle-group"
          aria-label="Changes"
          [value]="sigOnly ? 'sig' : 'all'"
          (change)="onViewChange($event.value)"
        >
          <mat-button-toggle value="sig" [disabled]="loading">
            Significant Only
          </mat-button-toggle>
          <mat-button-toggle value="all" [disabled]="loading">
            All Changes
          </mat-button-toggle>
        </mat-button-toggle-group>
      }
      <button
        mat-button
        [mat-dialog-close]=""
        (click)="onClose()"
        cdkFocusInitial
      >
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <div
    mat-dialog-content
    class="update-review dialog-content"
    #reviewContent
  >
    @if (loading) {
      <div class="review-loading">Loading...</div>
    } @else {
      @for (sc of sections; track sc) {
      <div>
        <h4 class="sectionTitle">
          Section&nbsp;{{sc.rbSectNum}}:&nbsp;{{sc.rbSectName}}
        </h4>
        @for (p of sc.para; track p) {
        <div class="para">
          <div class="b">Para&nbsp;{{p.paraNum}}</div>
          @if (isMissingInView(p)) {
          <div class="missing-in-view">
            @if (contentView === "new") {
            This paragraph was removed in the current version.
            } @else {
            This paragraph is new; it is not in the previous version.
            }
          </div>
          <br />
          } @else {
          <div>Question:</div>
          <div class="diff-html" [innerHTML]="viewHtml(p, 'question')"></div>
          <br />
          <div class="diff-html" [innerHTML]="viewHtml(p, 'guidenote')"></div>
          <br />
          }
        </div>
        }
      </div>
      }
    }
  </div>
  <div mat-dialog-actions>
    <div>
      <button mat-button (click)="onPrint()" class="button-close">
        Print
      </button>
      <button
        mat-button
        (click)="onRemoveFlag()"
        class="button-close"
        cdkFocusInitial
      >
        Remove flag
      </button>
      <button
        mat-button
        (click)="onClose()"
        mat-dialog-close
        class="button-close"
      >
        Close
      </button>
    </div>
  </div>
</div>
